<template>
  <div id="data-list-thumb-view" class="data-list-container">
    <vs-table
      ref="table"
      v-model="selected"
      pagination
      :max-items="itemsPerPage"
      search
      :data="tickets"
    >
      <div slot="header" class="flex flex-wrap-reverse items-center justify-between flex-grow">
        <div class="flex flex-wrap-reverse items-center">
          <div
            class="flex items-center justify-between p-3 mb-4 mr-4 text-base text-lg font-medium border border-solid rounded-lg cursor-pointer text-primary border-primary"
          >
            <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
            <router-link to="/tickets/new">
              <span class="ml-2 text-base text-primary">Create New Ticket</span>
            </router-link>
          </div>
        </div>

        <!-- ITEMS PER PAGE -->
        <vs-dropdown vs-trigger-click class="mb-4 mr-4 cursor-pointer">
          <div
            class="flex items-center justify-between p-4 font-medium border border-solid rounded-full cursor-pointer d-theme-border-grey-light d-theme-dark-bg"
          >
            <span
              class="mr-2"
            >{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{ tickets.length - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : tickets.length }} of {{ queriedItems }}</span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
          <vs-dropdown-menu>
            <vs-dropdown-item @click="itemsPerPage=4">
              <span>4</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=10">
              <span>10</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=15">
              <span>15</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=20">
              <span>20</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>

      <template slot="thead">
        <vs-th sort-key="priority">Priority</vs-th>
        <vs-th sort-key="title">Title</vs-th>
        <vs-th sort-key="createdAt">Created At</vs-th>
        <vs-th sort-key="updatedAt">Updated At</vs-th>
        <vs-th sort-key="status">Status</vs-th>
        <vs-th sort-key="createdBy" v-if="isAdmin">Created By</vs-th>
        <vs-th>Action</vs-th>
      </template>

      <template slot-scope="{data}">
        <tbody>
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <router-link :to="`/tickets/details/${tr._id}`" class="routerLink">
              <!-- Priority -->
              <vs-td class="centered-cell">
                <vs-chip :color="getPriorityColor(tr.priority)">{{getPriorityName(tr.priority)}}</vs-chip>
              </vs-td>
              <!-- Title -->
              <vs-td class="centered-cell">
                <p>{{tr.title}}</p>
              </vs-td>
              <!-- Created At -->
              <vs-td class="centered-cell">
                <p>{{ tr.createdAt | moment('DD/MM/YYYY HH:mm')}}</p>
              </vs-td>
              <!-- Updated At -->
              <vs-td class="centered-cell">
                <p>{{ tr.updatedAt | moment('DD/MM/YYYY HH:mm')}}</p>
              </vs-td>
              <!-- Status -->
              <vs-td class="centered-cell">
                <template v-if="tr.status === 1">
                  <vs-chip color="success">Open</vs-chip>
                </template>
                <template v-if="tr.status === 0">
                  <vs-chip color="danger">Closed</vs-chip>
                </template>
              </vs-td>
              <!-- Created By -->
              <vs-td v-if="isAdmin" class="centered-cell">{{tr.createdBy === null ? 'Deleted User' : tr.createdBy.fullName}}</vs-td>
            </router-link>
            <vs-td class="whitespace-no-wrap centered-cell">
              <feather-icon
                icon="LockIcon"
                svgClasses="w-5 h-5 hover:text-danger stroke-current"
                class="ml-2"
                @click.stop="closeTicket(tr._id)"
              />
            </vs-td>
          </vs-tr>
        </tbody>
      </template>
    </vs-table>
  </div>
</template>

<script>
import eventBus from '../../eventBus'

export default {
  data () {
    return {
      selected: [],
      tickets: [],
      itemsPerPage: 4,
      isMounted: false,
      addNewDataSidebar: false
    }
  },
  computed: {
    isAdmin () {
      return this.$store.state.AppActiveUser.userType === 'Admin'
    },
    currentPage () {
      if (this.isMounted) {
        return this.$refs.table.currentx
      }
      return 0
    },
    queriedItems () {
      return this.$refs.table
        ? this.$refs.table.queriedResults.length
        : this.tickets.length
    }
  },
  methods: {
    getPriorityName (priority) {
      switch (priority) {
      case 3:
        return 'High'
      case 2:
        return 'Medium'
      case 1:
        return 'Low'
      default:
        return 'Unspecified'
      }
    },
    getPriorityColor (priority) {
      switch (priority) {
      case 3:
        return 'danger'
      case 2:
        return 'warning'
      case 1:
        return 'success'
      default:
        return 'dark'
      }
    },
    refreshTable () {
      this.$http.get('/user/tickets').then(res => {
        this.tickets = res.data.tickets
      })
    },
    getImage (image_id) {
      return `${process.env.VUE_APP_BASE_URL}/images/${image_id}`
    },
    closeTicket (id) {
      this.$swal({
        title: 'Do you really want to close the ticket?',
        text: 'You won\'t be able to revert this!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, close it!'
      }).then(result => {
        if (result.value) {
          this.$http
            .put('/user/tickets', { _id: id, status: 0 })
            .then(res => {
              this.refreshTable()
              if (res.data.status === true) {
                this.$swal({
                  position: 'bottom-start',
                  icon: 'success',
                  toast: true,
                  title: 'Ticket successfully closed.',
                  showConfirmButton: false,
                  timer: 3000,
                  timerProgressBar: true
                })
              } else {
                this.$swal({
                  position: 'bottom-start',
                  icon: 'error',
                  toast: true,
                  title: 'Error occurred closing the ticket.',
                  showConfirmButton: false,
                  timer: 3000,
                  timerProgressBar: true
                })
              }
            })
            .catch(err => {
              this.refreshTable()
              this.$swal({
                position: 'bottom-start',
                icon: 'error',
                toast: true,
                title: 'Error occurred closing the ticket.',
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true
              })
            })
        }
      })
    }
  },
  created () {
    this.refreshTable()
  },
  mounted () {
    this.isMounted = true
  }
}
</script>

<style lang="scss">
#data-list-thumb-view {
  .vs-con-table {
    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;
      tr:hover {
        transform: translate(0) !important;
        background: rgba(var(--vs-primary), 0.05) !important;
      }
      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
        td {
          padding: 10px;
          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }
          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
          &.img-container {
            // width: 1rem;
            // background: #fff;

            span {
              display: flex;
              justify-content: flex-start;
            }

            .product-img {
              height: 110px;
            }
          }
        }
        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check {
        padding: 0 15px !important;
      }
      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
.centered-cell {
  display: table-cell;
  vertical-align: middle;
}
</style>